document.addEventListener('DOMContentLoaded', function () {
  $(document).on('swell:setup', function () {
    var vipTiers = swellAPI.getVipTiers();
    var customerDetails = swellAPI.getCustomerDetails();
    console.log({ vipTiers });
    console.log({ customerDetails });
    renderLoyaltyInfoWidget();
    renderTierWidget();
    updateData();
    $('body').addClass('yotpo-loaded');

    function updateData() {
      $('.js-yotpo-tier').text(customerDetails?.vipTier?.name);
      $('.js-yotpo-points').text(customerDetails?.pointsBalance);
    }
    window.updateLoyaltyData = updateData;

    // vipTiers.forEach(function(tier){
    //   console.log(tier);
    // });

    function renderLoyaltyInfoWidget() {
      var vipTiers = swellAPI.getVipTiers();
      var customerDetails = swellAPI.getCustomerDetails();
      var pointsBalance = customerDetails.pointsBalance;
      var redemptionOptions = swellAPI
        .getActiveRedemptionOptions()
        .sort((a, b) => a.costInPoints - b.costInPoints);
      var nextTarget = redemptionOptions.find((item) => item.costInPoints > pointsBalance);
      var pointsLeft = undefined;
      if (nextTarget) {
        pointsLeft = nextTarget.costInPoints - pointsBalance;
      }
      var html = `
        <div class="loyalty-info">
          <div class="loyalty-info__heading">
            <span class="fw-500">
              Loyalty
            </span>

            ${
              customerDetails.vipTier && customerDetails.vipTier.name
                ? `
                <span class="fw-400">
                  Level:
                  <span class="loyalty-rank">
                    ${customerDetails.vipTier.name}
                  </span>
                </span>
              `
                : ''
            }
          </div>
          <div class="loyalty-info__points">
            <div class="loyalty-info__points--info" >
              <span class="points">
                ${pointsBalance}
              </span>
              <span>
                points
              </span>
            </div>


            ${
              nextTarget
                ? `
                <div class="points-progress">
                  <span style="width: ${(1 - pointsLeft / nextTarget.costInPoints) * 100}%;">
                  </span>
                </div>

                <p>
                  ${pointsLeft} Points away from ${nextTarget.name}
                </p>
              `
                : ''
            }
          </div>
        </div>
      `;
      $('.js-loyalty-info').html('');
      $(html).hide().appendTo('.js-loyalty-info').fadeIn();
    }

    function renderTierWidget() {
      // return;

      var customerDetails = swellAPI.getCustomerDetails();
      var vipTiers = swellAPI.getVipTiers();
      var amountNeeded = customerDetails.vipTierStatsNeeded.amountSpentCents / 100;
      var amountSpent = customerDetails.vipTierStats.amountSpentCents / 100;
      var pointsNeeded = customerDetails.vipTierStatsNeeded.pointsEarned;
      var pointsEarned = customerDetails.vipTierStats.pointsEarned;
      var pointsPercent = (pointsEarned / (pointsNeeded + pointsEarned)) * 100;
      var percent = (amountSpent / (amountNeeded + amountSpent)) * 100;
      var currentTier = customerDetails.vipTier;

      if (currentTier) {
        var nextTier = null;
        vipTiers.some(function (tier, index) {
          if (tier.id == currentTier.id) {
            if (index < vipTiers.length - 1) {
              nextTier = vipTiers[index + 1];
              return true;
            }
          }
        });

        if (nextTier && pointsNeeded > 0) {
          $('.js-yotpo-progress-text').text(`${pointsNeeded} away from ${nextTier.name}`);
          $('.js-yotpo-progress-width').attr('style', `width: ${pointsPercent}%;`);
        } else {
          $('.js-yotpo-progress-text').text('');
          $('.js-yotpo-progress-width').attr('style', `width: ${100}%;`);
        }

        if (nextTier && amountNeeded > 0) {
          var html = `
            <div class="loyalty-tier__section">
              <div class="loyalty-tier">
                <div class="loyalty-tier__container">
                  <div class="loyalty-tier__grid">
                    <div class="loyalty-tier__left">
                      <h4>
                        Tier status
                      </h4>

                      <p>
                        Spend $${amountNeeded.toLocaleString()} to unlock ${nextTier.name}
                      </p>
                    </div>
                    <div class="loyalty-tier__right">

                      <div class="loyalty-tier__progress">

                        <h4>
                          You
                        </h4>

                        <h4 style="text-align: right;">
                          ${currentTier.name}
                        </h4>

                        <div class="tier-progress">
                          <span style="width: ${percent}%;"></span>
                        </div>

                        <p>
                          $${amountSpent.toLocaleString()} Spent
                        </p>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          `;
          $('.js-loyalty-tier').html('');
          $(html).hide().appendTo('.js-loyalty-tier').fadeIn();
        }
      }
    }
  });
});
